import { type DeepPartial } from '@direct-frontend/stdlib';
import { type PromoactionMode, type PromoactionModel, type PromoactionType } from './types';

export const getPromoactionTypeText = (promoaction: DeepPartial<PromoactionModel>): string => {
    const type = promoaction?.meta?.type;
    const mode = promoaction?.mode?.mode;

    if (type === 'ladder') {
        return 'Лестница скидок';
    }

    const map: Record<PromoactionMode, Record<Exclude<PromoactionType, 'ladder'>, string>> = {
        promocode: {
            on_orders: 'Промокод на заказ',
            on_products: 'Промокод на товары',
        },
        automatic: {
            on_orders: 'Скидка на заказ',
            on_products: 'Скидка на товары',
        },
    };

    if (!mode || !type) {
        return 'Тип скидки неизвестен';
    }

    return map[mode][type as Exclude<PromoactionType, 'ladder'>] ?? 'Тип скидки неизвестен';
};
